import { render, staticRenderFns } from "./platformTooltip.vue?vue&type=template&id=1ffec5e9"
import script from "./platformTooltip.vue?vue&type=script&lang=ts"
export * from "./platformTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports